import {
  ADD_LIST
  //   USER_INFO,
  //   CREATE_GROUP
} from './mutation-types.js'
// import {
//   queryUserInfo,
//   createGroup
// } from '../service/header.js'
export default {
  addList (context) {
    context.commit(ADD_LIST, '1')
  }
  //   getUserInfo (context) {
  //     queryUserInfo().then(function (response) {
  //       context.commit(USER_INFO, response)
  //     })
  //       .catch(function (error) {
  //         console.log(error)
  //       })
  //   },
  //   createGroup (context) {
  //     createGroup().then(function (response) {
  //       context.commit(CREATE_GROUP, response)
  //     })
  //       .catch(function (error) {
  //         console.log(error)
  //       })
  //   }
}
